var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRestroom = function SvgRestroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#263F54",
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M1 12C1 5.925 5.925 1 12 1h16c6.075 0 11 4.925 11 11v16c0 6.075-4.925 11-11 11H12C5.925 39 1 34.075 1 28z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeMiterlimit: 10,
    d: "M11.875 23.43v-5.227a2.754 2.754 0 1 1 5.51 0v5.227m2.93 0s.889-5.068 1.348-6.262c.388-1.019 1.4-1.72 2.554-1.72s2.155.683 2.543 1.684c.483 1.26 1.366 6.163 1.366 6.163m-14.55-1.283v7.063m2.114 0v-7.063m9.893-2.596 1.16 5.592H25.27v4.067m-2.419-9.659-1.165 5.592h1.471v4.067M16.083 12.33a1.454 1.454 0 1 1-2.907 0 1.454 1.454 0 0 1 2.907 0Zm9.589 0a1.454 1.454 0 1 1-2.908 0 1.454 1.454 0 0 1 2.908 0Z"
  })));
};
export default SvgRestroom;